export default __webpack_public_path__ + "static/media/background.04fa682f.webp";